import classNames from "classnames"
import s from "../../../../index.module.css"
import classes from "./index.module.css"
import { toggleIntersectionCheckRole } from "@store/timetable/timetableSlice"
import { useDispatch, useSelector } from "react-redux"
import rolesEnum from "@/constant/rolesEnum"

export const Tabs = () => {

    return (
        <div className={s.tabs}>
            <Button tab={rolesEnum.children} text='Ученик' />
            <Button tab={rolesEnum.seminarian} text='Педагог' />
        </div>
    )
}

const Button = ({text, tab}) => {
    const dispatch = useDispatch();
    const activeTab = useSelector(state => state.timetable.intersectionCheck.role);

    return(
        <button
            onClick={() => dispatch(toggleIntersectionCheckRole(tab))}
            className={
                classNames(
                    s.tabButton,
                    classes.button,
                    {[s.tabButtonActive]: tab === activeTab}
                )
            }
        >
            { text }
        </button>
    )
}